import { jsx as _jsx } from "react/jsx-runtime";
import { RequirablePropertyInputHomeCurrencyV2 } from '../../input/PropertyInputGetters';
import { useAdditionalPropertyValues } from '../hooks/useAdditionalPropertyValues';
import { usePropertyDefinition } from '../hooks/usePropertyDefinition';

const PropertyInputCurrencyShimV2 = props => {
  const propertyDefinition = usePropertyDefinition();
  const propertiesToFetch = propertyDefinition.currencyPropertyName ? [propertyDefinition.currencyPropertyName] : [];
  const [subjectCurrencyCode] = useAdditionalPropertyValues(propertiesToFetch); // no `resolverType` needed; the shim ensures that reference resolvers are
  // provided (for use by ResolverReferences inside the leaf input)

  return /*#__PURE__*/_jsx(RequirablePropertyInputHomeCurrencyV2, Object.assign({}, props, {
    subjectCurrencyCode: subjectCurrencyCode
  }));
};

export default PropertyInputCurrencyShimV2;